// extracted by mini-css-extract-plugin
export default {"wrapper":"phonebook_wrapper__dwyH0","title":"phonebook_title__q-5EP"};